<template>
    <div class='card'>
        <BioDataTable ref="sampleStorageTable" 
            :needSelfAdption="true" 
            :columns="columns"
            :is-dto="true"
            operate-column-style='width: 77px;' 
            :showColumnParams="{ module: 'SampleStorage', tableName: 'table1' }"
            :rows='50' 
             scroll-height="50vh"
            :operate-column-show="false"
            export-file-name="sampleStatus"
            url="/user/sample"
            :paramsBody="{micAccountName: micAccountName}"
            />
            <!-- :table-data ="tableData" -->
            <!--     url="/user/sample"
            :paramsBody="{micAccountName: micAccountName}"-->
    </div>
</template>

<script>

import BioDataTable from '@/components/BioDataTable/BioDataTable.vue';
import requests from '@/request';
export default {
    components: { BioDataTable },
    data() {
        return {
            operateButtons: [
                {
                    className:'',
                    icon: 'pi pi-eye',
                    label: '',
                    style:'',
                    click: (row) => {
                        this.findvalues(row);
                    },
                    buttonStrategy:()=>{
                        return true
                    },
                    title:'Report'
                },
            ],
            tableData: [
                {
                    projectId: 'PP0103A0001',
                    projectName: 'Your-Project-1',
                    clientSampleId: 'PP0103A0001',
                    status: 'Used',
                    patientId: 'PP0103A0001',
                    predicineSampleId: 'PP0103A0001',
                    sampleBarcode: 'PP0103A0001',
                    dateReceived: 'PP0103A0001',
                    externalTrialVisit: 'PP0103A0001',
                    accessionQuantity: 'PP0103A0001',
                    accessionUnit: 'PP0103A0001',
                    currentQuantity: 'PP0103A0001',
                    currentUnit: 'PP0103A0001',
                    tumorFraction: 'PP0103A0001',
                },
                {
                    projectId: 'PP0103A0002',
                    projectName: 'Your-Project-2',
                    clientSampleId: 'PP0103A0002',
                    status: 'Accessioned',
                    patientId: 'PP0103A0002',
                    predicineSampleId: 'PP0103A0002',
                    sampleBarcode: 'PP0103A0002',
                    dateReceived: 'PP0103A0002',
                    externalTrialVisit: 'PP0103A0002',
                    accessionQuantity: 'PP0103A0002',
                    accessionUnit: 'PP0103A0002',
                    currentQuantity: 'PP0103A0002',
                    currentUnit: 'PP0103A0002',
                    tumorFraction: 'PP0103A0002',
                },
                {
                    projectId: 'PP0103A0001',
                    projectName: 'Your-Project-1',
                    clientSampleId: 'PP0103A0001',
                    status: 'Destroyed',
                    patientId: 'PP0103A0001',
                    predicineSampleId: 'PP0103A0001',
                    sampleBarcode: 'PP0103A0001',
                    dateReceived: 'PP0103A0001',
                    externalTrialVisit: 'PP0103A0001',
                    accessionQuantity: 'PP0103A0001',
                    accessionUnit: 'PP0103A0001',
                    currentQuantity: 'PP0103A0001',
                    currentUnit: 'PP0103A0001',
                    tumorFraction: 'PP0103A0001',
                },
                {
                    projectId: 'PP0103A0002',
                    projectName: 'Your-Project-2',
                    clientSampleId: 'PP0103A0002',
                    status: 'Deli22vered',
                    patientId: 'PP0103A0002',
                    predicineSampleId: 'PP0103A0002',
                    sampleBarcode: 'PP0103A0002',
                    dateReceived: 'PP0103A0002',
                    externalTrialVisit: 'PP0103A0002',
                    accessionQuantity: 'PP0103A0002',
                    accessionUnit: 'PP0103A0002',
                    currentQuantity: 'PP0103A0002',
                    currentUnit: 'PP0103A0002',
                    tumorFraction: 'PP0103A0002',
                },
                {
                    projectId: 'PP0103A0001',
                    projectName: 'Your-Project-1',
                    clientSampleId: 'PP0103A0001',
                    status: 'Delivered',
                    patientId: 'PP0103A0001',
                    predicineSampleId: 'PP0103A0001',
                    sampleBarcode: 'PP0103A0001',
                    dateReceived: 'PP0103A0001',
                    externalTrialVisit: 'PP0103A0001',
                    accessionQuantity: 'PP0103A0001',
                    accessionUnit: 'PP0103A0001',
                    currentQuantity: 'PP0103A0001',
                    currentUnit: 'PP0103A0001',
                    tumorFraction: 'PP0103A0001',
                },
                {
                    projectId: 'PP0103A0002',
                    projectName: 'Your-Project-2',
                    clientSampleId: 'PP0103A0002',
                    status: 'Deli22vered',
                    patientId: 'PP0103A0002',
                    predicineSampleId: 'PP0103A0002',
                    sampleBarcode: 'PP0103A0002',
                    dateReceived: 'PP0103A0002',
                    externalTrialVisit: 'PP0103A0002',
                    accessionQuantity: 'PP0103A0002',
                    accessionUnit: 'PP0103A0002',
                    currentQuantity: 'PP0103A0002',
                    currentUnit: 'PP0103A0002',
                    tumorFraction: 'PP0103A0002',
                },
                {
                    projectId: 'PP0103A0001',
                    projectName: 'Your-Project-1',
                    clientSampleId: 'PP0103A0001',
                    status: 'Delivered',
                    patientId: 'PP0103A0001',
                    predicineSampleId: 'PP0103A0001',
                    sampleBarcode: 'PP0103A0001',
                    dateReceived: 'PP0103A0001',
                    externalTrialVisit: 'PP0103A0001',
                    accessionQuantity: 'PP0103A0001',
                    accessionUnit: 'PP0103A0001',
                    currentQuantity: 'PP0103A0001',
                    currentUnit: 'PP0103A0001',
                    tumorFraction: 'PP0103A0001',
                },
                {
                    projectId: 'PP0103A0002',
                    projectName: 'Your-Project-2',
                    clientSampleId: 'PP0103A0002',
                    status: 'Deli22vered',
                    patientId: 'PP0103A0002',
                    predicineSampleId: 'PP0103A0002',
                    sampleBarcode: 'PP0103A0002',
                    dateReceived: 'PP0103A0002',
                    externalTrialVisit: 'PP0103A0002',
                    accessionQuantity: 'PP0103A0002',
                    accessionUnit: 'PP0103A0002',
                    currentQuantity: 'PP0103A0002',
                    currentUnit: 'PP0103A0002',
                    tumorFraction: 'PP0103A0002',
                },
                {
                    projectId: 'PP0103A0001',
                    projectName: 'Your-Project-1',
                    clientSampleId: 'PP0103A0001',
                    status: 'Delivered',
                    patientId: 'PP0103A0001',
                    predicineSampleId: 'PP0103A0001',
                    sampleBarcode: 'PP0103A0001',
                    dateReceived: 'PP0103A0001',
                    externalTrialVisit: 'PP0103A0001',
                    accessionQuantity: 'PP0103A0001',
                    accessionUnit: 'PP0103A0001',
                    currentQuantity: 'PP0103A0001',
                    currentUnit: 'PP0103A0001',
                    tumorFraction: 'PP0103A0001',
                },
                {
                    projectId: 'PP0103A0002',
                    projectName: 'Your-Project-2',
                    clientSampleId: 'PP0103A0002',
                    status: 'Deli22vered',
                    patientId: 'PP0103A0002',
                    predicineSampleId: 'PP0103A0002',
                    sampleBarcode: 'PP0103A0002',
                    dateReceived: 'PP0103A0002',
                    externalTrialVisit: 'PP0103A0002',
                    accessionQuantity: 'PP0103A0002',
                    accessionUnit: 'PP0103A0002',
                    currentQuantity: 'PP0103A0002',
                    currentUnit: 'PP0103A0002',
                    tumorFraction: 'PP0103A0002',
                },
                {
                    projectId: 'PP0103A0001',
                    projectName: 'Your-Project-1',
                    clientSampleId: 'PP0103A0001',
                    status: 'Delivered',
                    patientId: 'PP0103A0001',
                    predicineSampleId: 'PP0103A0001',
                    sampleBarcode: 'PP0103A0001',
                    dateReceived: 'PP0103A0001',
                    externalTrialVisit: 'PP0103A0001',
                    accessionQuantity: 'PP0103A0001',
                    accessionUnit: 'PP0103A0001',
                    currentQuantity: 'PP0103A0001',
                    currentUnit: 'PP0103A0001',
                    tumorFraction: 'PP0103A0001',
                },
                {
                    projectId: 'PP0103A0002',
                    projectName: 'Your-Project-2',
                    clientSampleId: 'PP0103A0002',
                    status: 'Deli22vered',
                    patientId: 'PP0103A0002',
                    predicineSampleId: 'PP0103A0002',
                    sampleBarcode: 'PP0103A0002',
                    dateReceived: 'PP0103A0002',
                    externalTrialVisit: 'PP0103A0002',
                    accessionQuantity: 'PP0103A0002',
                    accessionUnit: 'PP0103A0002',
                    currentQuantity: 'PP0103A0002',
                    currentUnit: 'PP0103A0002',
                    tumorFraction: 'PP0103A0002',
                },
                {
                    projectId: 'PP0103A0001',
                    projectName: 'Your-Project-1',
                    clientSampleId: 'PP0103A0001',
                    status: 'Delivered',
                    patientId: 'PP0103A0001',
                    predicineSampleId: 'PP0103A0001',
                    sampleBarcode: 'PP0103A0001',
                    dateReceived: 'PP0103A0001',
                    externalTrialVisit: 'PP0103A0001',
                    accessionQuantity: 'PP0103A0001',
                    accessionUnit: 'PP0103A0001',
                    currentQuantity: 'PP0103A0001',
                    currentUnit: 'PP0103A0001',
                    tumorFraction: 'PP0103A0001',
                },
                {
                    projectId: 'PP0103A0002',
                    projectName: 'Your-Project-2',
                    clientSampleId: 'PP0103A0002',
                    status: 'Deli22vered',
                    patientId: 'PP0103A0002',
                    predicineSampleId: 'PP0103A0002',
                    sampleBarcode: 'PP0103A0002',
                    dateReceived: 'PP0103A0002',
                    externalTrialVisit: 'PP0103A0002',
                    accessionQuantity: 'PP0103A0002',
                    accessionUnit: 'PP0103A0002',
                    currentQuantity: 'PP0103A0002',
                    currentUnit: 'PP0103A0002',
                    tumorFraction: 'PP0103A0002',
                },
                {
                    projectId: 'PP0103A0001',
                    projectName: 'Your-Project-1',
                    clientSampleId: 'PP0103A0001',
                    status: 'Delivered',
                    patientId: 'PP0103A0001',
                    predicineSampleId: 'PP0103A0001',
                    sampleBarcode: 'PP0103A0001',
                    dateReceived: 'PP0103A0001',
                    externalTrialVisit: 'PP0103A0001',
                    accessionQuantity: 'PP0103A0001',
                    accessionUnit: 'PP0103A0001',
                    currentQuantity: 'PP0103A0001',
                    currentUnit: 'PP0103A0001',
                    tumorFraction: 'PP0103A0001',
                },
                {
                    projectId: 'PP0103A0002',
                    projectName: 'Your-Project-2',
                    clientSampleId: 'PP0103A0002',
                    status: 'Deli22vered',
                    patientId: 'PP0103A0002',
                    predicineSampleId: 'PP0103A0002',
                    sampleBarcode: 'PP0103A0002',
                    dateReceived: 'PP0103A0002',
                    externalTrialVisit: 'PP0103A0002',
                    accessionQuantity: 'PP0103A0002',
                    accessionUnit: 'PP0103A0002',
                    currentQuantity: 'PP0103A0002',
                    currentUnit: 'PP0103A0002',
                    tumorFraction: 'PP0103A0002',
                },
                {
                    projectId: 'PP0103A0001',
                    projectName: 'Your-Project-1',
                    clientSampleId: 'PP0103A0001',
                    status: 'Delivered',
                    patientId: 'PP0103A0001',
                    predicineSampleId: 'PP0103A0001',
                    sampleBarcode: 'PP0103A0001',
                    dateReceived: 'PP0103A0001',
                    externalTrialVisit: 'PP0103A0001',
                    accessionQuantity: 'PP0103A0001',
                    accessionUnit: 'PP0103A0001',
                    currentQuantity: 'PP0103A0001',
                    currentUnit: 'PP0103A0001',
                    tumorFraction: 'PP0103A0001',
                },
                {
                    projectId: 'PP0103A0002',
                    projectName: 'Your-Project-2',
                    clientSampleId: 'PP0103A0002',
                    status: 'Deli22vered',
                    patientId: 'PP0103A0002',
                    predicineSampleId: 'PP0103A0002',
                    sampleBarcode: 'PP0103A0002',
                    dateReceived: 'PP0103A0002',
                    externalTrialVisit: 'PP0103A0002',
                    accessionQuantity: 'PP0103A0002',
                    accessionUnit: 'PP0103A0002',
                    currentQuantity: 'PP0103A0002',
                    currentUnit: 'PP0103A0002',
                    tumorFraction: 'PP0103A0002',
                },
                {
                    projectId: 'PP0103A0001',
                    projectName: 'Your-Project-1',
                    clientSampleId: 'PP0103A0001',
                    status: 'Delivered',
                    patientId: 'PP0103A0001',
                    predicineSampleId: 'PP0103A0001',
                    sampleBarcode: 'PP0103A0001',
                    dateReceived: 'PP0103A0001',
                    externalTrialVisit: 'PP0103A0001',
                    accessionQuantity: 'PP0103A0001',
                    accessionUnit: 'PP0103A0001',
                    currentQuantity: 'PP0103A0001',
                    currentUnit: 'PP0103A0001',
                    tumorFraction: 'PP0103A0001',
                },
                {
                    projectId: 'PP0103A0002',
                    projectName: 'Your-Project-2',
                    clientSampleId: 'PP0103A0002',
                    status: 'Deli22vered',
                    patientId: 'PP0103A0002',
                    predicineSampleId: 'PP0103A0002',
                    sampleBarcode: 'PP0103A0002',
                    dateReceived: 'PP0103A0002',
                    externalTrialVisit: 'PP0103A0002',
                    accessionQuantity: 'PP0103A0002',
                    accessionUnit: 'PP0103A0002',
                    currentQuantity: 'PP0103A0002',
                    currentUnit: 'PP0103A0002',
                    tumorFraction: 'PP0103A0002',
                },
                {
                    projectId: 'PP0103A0001',
                    projectName: 'Your-Project-1',
                    clientSampleId: 'PP0103A0001',
                    status: 'Delivered',
                    patientId: 'PP0103A0001',
                    predicineSampleId: 'PP0103A0001',
                    sampleBarcode: 'PP0103A0001',
                    dateReceived: 'PP0103A0001',
                    externalTrialVisit: 'PP0103A0001',
                    accessionQuantity: 'PP0103A0001',
                    accessionUnit: 'PP0103A0001',
                    currentQuantity: 'PP0103A0001',
                    currentUnit: 'PP0103A0001',
                    tumorFraction: 'PP0103A0001',
                },
                {
                    projectId: 'PP0103A0002',
                    projectName: 'Your-Project-2',
                    clientSampleId: 'PP0103A0002',
                    status: 'Deli22vered',
                    patientId: 'PP0103A0002',
                    predicineSampleId: 'PP0103A0002',
                    sampleBarcode: 'PP0103A0002',
                    dateReceived: 'PP0103A0002',
                    externalTrialVisit: 'PP0103A0002',
                    accessionQuantity: 'PP0103A0002',
                    accessionUnit: 'PP0103A0002',
                    currentQuantity: 'PP0103A0002',
                    currentUnit: 'PP0103A0002',
                    tumorFraction: 'PP0103A0002',
                },
                {
                    projectId: 'PP0103A0001',
                    projectName: 'Your-Project-1',
                    clientSampleId: 'PP0103A0001',
                    status: 'Delivered',
                    patientId: 'PP0103A0001',
                    predicineSampleId: 'PP0103A0001',
                    sampleBarcode: 'PP0103A0001',
                    dateReceived: 'PP0103A0001',
                    externalTrialVisit: 'PP0103A0001',
                    accessionQuantity: 'PP0103A0001',
                    accessionUnit: 'PP0103A0001',
                    currentQuantity: 'PP0103A0001',
                    currentUnit: 'PP0103A0001',
                    tumorFraction: 'PP0103A0001',
                },
                {
                    projectId: 'PP0103A0002',
                    projectName: 'Your-Project-2',
                    clientSampleId: 'PP0103A0002',
                    status: 'Deli22vered',
                    patientId: 'PP0103A0002',
                    predicineSampleId: 'PP0103A0002',
                    sampleBarcode: 'PP0103A0002',
                    dateReceived: 'PP0103A0002',
                    externalTrialVisit: 'PP0103A0002',
                    accessionQuantity: 'PP0103A0002',
                    accessionUnit: 'PP0103A0002',
                    currentQuantity: 'PP0103A0002',
                    currentUnit: 'PP0103A0002',
                    tumorFraction: 'PP0103A0002',
                },
                {
                    projectId: 'PP0103A0001',
                    projectName: 'Your-Project-1',
                    clientSampleId: 'PP0103A0001',
                    status: 'Delivered',
                    patientId: 'PP0103A0001',
                    predicineSampleId: 'PP0103A0001',
                    sampleBarcode: 'PP0103A0001',
                    dateReceived: 'PP0103A0001',
                    externalTrialVisit: 'PP0103A0001',
                    accessionQuantity: 'PP0103A0001',
                    accessionUnit: 'PP0103A0001',
                    currentQuantity: 'PP0103A0001',
                    currentUnit: 'PP0103A0001',
                    tumorFraction: 'PP0103A0001',
                },
                {
                    projectId: 'PP0103A0002',
                    projectName: 'Your-Project-2',
                    clientSampleId: 'PP0103A0002',
                    status: 'Deli22vered',
                    patientId: 'PP0103A0002',
                    predicineSampleId: 'PP0103A0002',
                    sampleBarcode: 'PP0103A0002',
                    dateReceived: 'PP0103A0002',
                    externalTrialVisit: 'PP0103A0002',
                    accessionQuantity: 'PP0103A0002',
                    accessionUnit: 'PP0103A0002',
                    currentQuantity: 'PP0103A0002',
                    currentUnit: 'PP0103A0002',
                    tumorFraction: 'PP0103A0002',
                },
                {
                    projectId: 'PP0103A0001',
                    projectName: 'Your-Project-1',
                    clientSampleId: 'PP0103A0001',
                    status: 'Delivered',
                    patientId: 'PP0103A0001',
                    predicineSampleId: 'PP0103A0001',
                    sampleBarcode: 'PP0103A0001',
                    dateReceived: 'PP0103A0001',
                    externalTrialVisit: 'PP0103A0001',
                    accessionQuantity: 'PP0103A0001',
                    accessionUnit: 'PP0103A0001',
                    currentQuantity: 'PP0103A0001',
                    currentUnit: 'PP0103A0001',
                    tumorFraction: 'PP0103A0001',
                },
                {
                    projectId: 'PP0103A0002',
                    projectName: 'Your-Project-2',
                    clientSampleId: 'PP0103A0002',
                    status: 'Deli22vered',
                    patientId: 'PP0103A0002',
                    predicineSampleId: 'PP0103A0002',
                    sampleBarcode: 'PP0103A0002',
                    dateReceived: 'PP0103A0002',
                    externalTrialVisit: 'PP0103A0002',
                    accessionQuantity: 'PP0103A0002',
                    accessionUnit: 'PP0103A0002',
                    currentQuantity: 'PP0103A0002',
                    currentUnit: 'PP0103A0002',
                    tumorFraction: 'PP0103A0002',
                },
                {
                    projectId: 'PP0103A0001',
                    projectName: 'Your-Project-1',
                    clientSampleId: 'PP0103A0001',
                    status: 'Delivered',
                    patientId: 'PP0103A0001',
                    predicineSampleId: 'PP0103A0001',
                    sampleBarcode: 'PP0103A0001',
                    dateReceived: 'PP0103A0001',
                    externalTrialVisit: 'PP0103A0001',
                    accessionQuantity: 'PP0103A0001',
                    accessionUnit: 'PP0103A0001',
                    currentQuantity: 'PP0103A0001',
                    currentUnit: 'PP0103A0001',
                    tumorFraction: 'PP0103A0001',
                },
                {
                    projectId: 'PP0103A0002',
                    projectName: 'Your-Project-2',
                    clientSampleId: 'PP0103A0002',
                    status: 'Deli22vered',
                    patientId: 'PP0103A0002',
                    predicineSampleId: 'PP0103A0002',
                    sampleBarcode: 'PP0103A0002',
                    dateReceived: 'PP0103A0002',
                    externalTrialVisit: 'PP0103A0002',
                    accessionQuantity: 'PP0103A0002',
                    accessionUnit: 'PP0103A0002',
                    currentQuantity: 'PP0103A0002',
                    currentUnit: 'PP0103A0002',
                    tumorFraction: 'PP0103A0002',
                },
            ],
            micAccountName: localStorage.getItem('micAccountName'),
            columns: [
                { field: "projectId", header: "Project ID", style: "width:180px", isEdit: false, isFilter: true,fixed :true, frozen:true},
                { field: "externalStudyId", header: "External Study ID", style: "width:180px", isEdit: false, isFilter: true,fixed :true, frozen:true},
                { field: "projectName", header: "Project Name", style: "width:180px", isEdit: false, isFilter: true ,fixed :true,frozen:true },
                { field: "clientSampleId", header: "Client Sample ID", style: "width:180px", isEdit: false, isFilter: true },
                { field: "sampleType", header: "Sample Type", style: "width:180px", isEdit: false, isFilter: true },
                { field: "status", header: "Status", style: "width:180px", isEdit: false, isFilter: true,
                    filterData:(status)=>{
                        if(status == 'Used'){
                            return 'Processing';
                        }
                        if(status == 'Accessioned'){
                            return 'In Storage';
                        }
                        return status;
                    },
                    dynamicClass:(status)=>{
                        if(status == 'Used'){
                            return 'colorClassByYellow';
                        }
                        if(status == 'Accessioned'){
                            return 'colorClassByGreen';
                        }
                        if(status == 'Destroyed'){
                            return 'colorClassGray';
                        }
                    },
                },
                { field: "patientId", header: "Patient / Subject ID", style: "width:180px", isEdit: false, isFilter: true },
                { field: "predicineSampleId", header: "Predicine Sample ID", style: "width:180px", isEdit: false, isFilter: true },
                // {
                //     field: "Report", header: "Report", style: "width:180px", isEdit: false, isFilter: true, type: 'btn', click: this.ReportClick, needEditFunction: (data) => {
                //         return data.status != 'Sequenced';
                //     },
                // },
                { field: "sampleBarcode", header: "Sample Barcode", style: "width:180px", isEdit: false, isFilter: true },
                { field: "dateReceived", header: "Date Received", style: "width:180px", isEdit: false, isFilter: true },
                { field: "trialVisitNumber", header: "Trial Visit", style: "width:180px", isEdit: false, isFilter: true },
                { field: "externalTrialVisit", header: "External Trial Visit", style: "width:180px", isEdit: false, isFilter: true },
                //增加字段  Trial Visit
                { field: "accessionQuantity", header: "Accession Quantity", style: "width:180px", isEdit: false, isFilter: true },
                { field: "currentUnit", header: "Quantity Unit", style: "width:180px", isEdit: false, isFilter: true },
                //{ field: "accessionUnit", header: "Quantity Unit", style: "width:180px", isEdit: false, isFilter: true },
                /*{ field: "currentQuantity", header: "Current Quantity", style: "width:180px", isEdit: false, isFilter: true },
                { field: "currentUnit", header: "Quantity Unit", style: "width:180px", isEdit: false, isFilter: true },*/
                //{field:"tumorFraction",header:"Tumor Fraction",style:"width:180px",isEdit: false,isFilter:true},
                // {field:"initialStorageLocation",header:"Initial Storage Location",style:"width:180px",isEdit: false,isFilter:true},

            ],
            urlQuery: {}
        };
    },
    created() {
    },
    mounted() {
        this.urlQuery = JSON.parse(sessionStorage.getItem('urlQuery'));
        if (this.urlQuery?.id) {
            this.$refs.sampleStorageTable.filters.global.value = this.urlQuery.id;
            this.$refs.sampleStorageTable.search();
            sessionStorage.removeItem('urlQuery');
        }
    },
    methods: {
        ReportClick(row) {
            // requests({
            //     url: '/file/downloadTemplate',
            //     method: 'post',
            //     headers: {
            //         'Content-Type': 'application/json;charset=UTF-8',
            //     },
            //     data: {
            //         formName: this.$t('SampleCenterClinicalReceive.clinicalSampleReception'),
            //         showId: this.sampleReceive.id || '',
            //     },
            // }).then((res) => {
            const link = document.createElement('a');
            //var pdfUrl = '/template/SampleCenter/TestReportFile.pdf';
            //window.open(pdfUrl, '_blank');
            link.href = '/template/SampleCenter/TestReportFile.pdf';
            link.target = '_blank';
            // link.download = this.$t('SampleCenterClinicalReceive.ResearchSampleReceiveTemplate') + '.xlsx';
            link.click();
            // });
        },
        sliceRendering(dataName, dom, data) {
            this[dataName] = [];
            let total = data.length;
            let once = 30;
            let index = 0;
            var that = this;
            that[dataName].push(...data.slice(index * once, (index + 1) * once));
            // console.log(...data.slice(index*once,(index+1)*once),'...data.slice(index*once,(index+1)*once)')
            index++;

            that.initTableTd();
            dom.scroll((e) => {
                var currentScroll = e.target.scrollTop + e.target.clientHeight;
                var endScroll = e.target.scrollHeight;
                that.initTableTd();
                if (currentScroll >= endScroll - 10) {
                    that[dataName].push(...data.slice(index * once, (index + 1) * once));
                    index++;
                }
            });
        },

        formatDate(value) {
            return value.toLocaleDateString('en-US', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        handleBeforeUnload() {
        },
        handleIconClick() {
            this.aiChat = true;
        },
    },
    beforeUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
    updated() {
        // console.log('App.vue finish re-render')
    },

};
</script>

<style lang='scss' scoped>

:deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #607D8B;
    }
}

.col_bbb {
    color: #bbb;
}

.widget-overview-box .overview-text {
    margin-top: 4px;
}

.widget-timeline .p-timeline .p-timeline-event-content .type {
    // padding: 0 4px;
    border-radius: 4px;
    color: #868C9B;
    margin-right: 8px;
}

.sameHeight {
    height: 555px !important;
    overflow: auto;
}

.widget-performance .content ul li .person-info {
    width: 100%;

    .amount {
        font-size: 14px;
    }

    .name {
        margin-top: 4px;

        span {
            float: right;
        }
    }
}

.widget-target {
    :deep(.p-timeline.p-timeline-vertical .p-timeline-event-opposite) {
        flex: 0;
        padding: 0;
    }

    :deep(.p-timeline.p-timeline-vertical .p-timeline-event-connector) {
        width: 0px
    }

    .p-timeline-event-content .type {
        margin-top: 4px;
        font-size: 12px;
        color: #868C9B;

        span {
            float: right;
        }
    }
}

.floating-icon {
    width: 50px;
    position: fixed;
    bottom: 20px;
    right: 20px;
    cursor: pointer;
    border: 1px solid #a0d2fa;
    border-radius: 50%;
    z-index: 999;
}

.title {
    font-weight: bold;
}
</style>
<style>
.colorClassByGreen{
background: #77BF43;
    color: #256029;
    border-radius: 2px;
    padding: .25em .5rem;
    //text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
    white-space:nowrap;
}
.colorClassByYellow{
background:  #FCB813;
    border-radius: 2px;
    padding: .25em .5rem;
    //text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
    white-space:nowrap;
}
.colorClassGray{
background: #AAAAAA;
    color: #666666;
    border-radius: 2px;
    padding: .25em .5rem;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
    white-space:nowrap;
}
.fixed-left {
    position: sticky !important;
    left: 0;
    z-index: 10;          /* 确保悬浮在最上层 */
    background-color: #fff; /* 避免滚动时透明穿透 */
}
</style>